import { render, staticRenderFns } from "./params-setting.vue?vue&type=template&id=16859b11&"
import script from "./params-setting.vue?vue&type=script&lang=ts&"
export * from "./params-setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports